import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { CoreModule } from './core/core.module';
import { AppEffects } from './app.effects';
import { SharedModule } from './shared/shared.module';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common'
import { routerReducer, RouterState, StoreRouterConnectingModule } from '@ngrx/router-store';
import { AgentEffectsModule } from './features/agent/agent-effects.module';
import { SidenavContentUserNavigationComponent } from './sidenav-content-user-navigation/sidenav-content-user-navigation.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConnectivityErrorInterceptor } from './shared/utils/interceptors/connectivity-error.interceptor';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';


@NgModule({
  declarations: [
    AppComponent,
    SidenavContentUserNavigationComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,

    StoreModule.forRoot({ router: routerReducer }, {
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true
      }
    }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),

    EffectsModule.forRoot([AppEffects]),

    StoreRouterConnectingModule.forRoot({
      stateKey: 'router',
      routerState: RouterState.Minimal
    }),

    CoreModule,
    SharedModule,
    AgentEffectsModule
  ],
  providers: [
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: {useUtc:true } },
    { provide: HTTP_INTERCEPTORS, useClass: ConnectivityErrorInterceptor, multi: true },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc:true } },
    { provide: MAT_DATE_LOCALE, useValue: "it-IT" }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
